import { Pipe, PipeTransform } from '@angular/core';
import { TravelCategory } from '../../api/models';

@Pipe({
  name: 'travelType'
})
export class TravelTypePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    let src: Map<number, string> = new Map([
      [1, "/assets/media/icons/worldwide.png"],
      [2, "/assets/media/icons/pray.png"],
      [3, "/assets/media/icons/shoes.png"],
      [4, "/assets/media/icons/nature.png"],
      [5, "/assets/media/icons/diamond.png"],
      [6, "/assets/media/icons/sea.png"],
    ])
    return (src.get(value)) || "/assets/media/icons/worldwide.png";
  }

}